// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"11637f27","88":"6b994099","407":"c68ed397","420":"b69a5435","454":"b3841b4d","739":"374c6a28","766":"c35fd262","783":"29877945","887":"f53663c8","907":"d837356c"}[chunkId] + ".chunk.css";
};